"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (proposal) {
    return proposal && +proposal.ask_price;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/trade/askPriceFromProposal.js
// module id = 388
// module chunks = 0